import { Button } from 'component/Button/Button'
import { Link } from 'component/Link'
import { Gap } from 'component/Space/Gap'
import { Vertical } from 'component/Vertical/Vertical'
import { i18n } from 'i18n'
import { observer } from 'mobx-react-lite'
import { ItemTitle } from 'page/tryon/BuyPane/ItemTitle'
import { store } from 'page/tryon/store/TryOnPageStore'
import { Inference, Item } from 'type/Inference'
import { Product } from 'type/Product'
import css from './BuyCard.module.scss'

type Props = {
  item: Item
}

function buildBuyLink(links?: string, product?: Product, inference?: Inference): string {
  if (!links) return ''
  try {
    const url = new URL(links)
    const { company_id } = product ?? {}
    const { inference_id, manager_id, access_key } = inference || {}
    const tsum = company_id === 'tsum_cs'
    if (inference_id) url.searchParams.append('inference_id', inference_id)
    if (tsum && access_key) url.searchParams.append('pvz_id', access_key)
    if (tsum && manager_id) url.searchParams.append('vr_manager_id', manager_id)
    return url.toString()
  } catch (e) {
    console.error(e)
    return links
  }
}

export const BuyCard = observer(({ item }: Props) => {
  const { inference, product } = store.it
  const { links } = item
  const shape = inference.items.length > 1
  const link = buildBuyLink(links, product, inference)

  return <Vertical className={css.root} flex="1" tall>
    <ItemTitle item={item} shape={shape} />
    {link && <Gap height={12} spring />}
    {link && <Link href={link} wide>
      <Button primary>
        {i18n('button.Buy')}
      </Button>
    </Link>}
  </Vertical>
})
